import Container from 'react-bootstrap/Container';
import { Alert, Button, Card, Table, Modal, Accordion, Form } from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {CallAPI, Loading, SpinnerX, Check, CallAPIGet} from '../../services/useBackend';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import {MaterialReactTable} from 'material-react-table';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle, metaLookUpAccountTitle} from '../../services/misc';
import { FaEdit, FaEraser, FaSortDown, FaSortUp, FaDownload, FaCheck } from 'react-icons/fa';
import { Document, Page, pdfjs  } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import axios from 'axios';
import { FileUploader } from "react-drag-drop-files";
import ModalImage, {Lightbox} from "react-modal-image";
import './../Menu.css';

//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
  ).toString();

export default function Test(props) {
    const [saving,        setSaving]        = useState(false);
    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);

    const [autoBalanceModalshow, setAutoBalanceModalshow] = useState(false);
    const [tranEditModalshow, setTranEditModalshow] = useState(false);    
    const [tranToEditData, setTranToEditData] = useState({});    

    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const [selectedFile, setSelectedFile] = useState(null);
    const fileTypes = ["pdf"];

    var PostDone = false;

    function onDocumentLoadSuccess(x) {
        setNumPages(x.numPages);
        setPageNumber(1);
        setResultVisible(false);
    }

    function setPageOffset(offset) {
        var newPageNumber = pageNumber + offset;

        if (newPageNumber<1) newPageNumber = 1;
        if (newPageNumber>numPages) newPageNumber = numPages;
        setPageNumber(newPageNumber);
    }

    async function autoBalance() {
		setSaving(true);
		setResultText("");
		setResultVisible(false);
		const VerificationForm = document.getElementById('FrmTemplate');
		const formData = new FormData(VerificationForm);
		const formDataObj = Object.fromEntries(formData.entries());
        //formDataObj.AutoBalanceTemplateId = 27;

		//formDataObj.expected_delivery = ConcatLocalDateAndTime2ISO(document.getElementById('expected_delivery').value);

        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/verifications/'+props.VerificationData.Verification.Guid + "/AutoBalance","PUT",JSON.stringify(formDataObj));
        if (resultVariant=="success") {
            props.setSelectedVerificationData(jsondata);
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);
            setAutoBalanceModalshow(false);
        } else {

        }
		setSaving(false);
    }

    async function verRound() {
		setSaving(true);
		setResultText("");
		setResultVisible(false);

        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/verifications/'+props.VerificationData.Verification.Guid + "/Round","PUT","");
        if (resultVariant=="success") {
            props.setSelectedVerificationData(jsondata);
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);
        } else {

        }
		setSaving(false);
    }

    async function verAddRow() {
		setSaving(true);
		setResultText("");
		setResultVisible(false);

        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/verifications/'+props.VerificationData.Verification.Guid + "/AddRow","PUT","");
        
        if (resultVariant=="success") {
            props.setSelectedVerificationData(jsondata);
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);
        }
		setSaving(false);
    }

    async function verRemoveRow(TransactionGuid) {
		setSaving(true);
		setResultText("");
		setResultVisible(false);

        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/verifications/'+props.VerificationData.Verification.Guid + "/RemoveRow/" + TransactionGuid,"PUT","");
        if (resultVariant=="success") {
            props.setSelectedVerificationData(jsondata);
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);
            setTranEditModalshow(false);
        } else {

        }
		setSaving(false);
    }

    async function editTranRow(tranRow){
        console.log(tranRow);
        setTranToEditData(tranRow); 
        setTranEditModalshow(true);
    }
    
    const [selectedWFData, setSelectedWFData] = useState({});

    var typingTimeout = null;
    var typingTimeoutTranRow = null;

	async function handleChange(event){
        
		if (props.VerificationData.Verification.Guid==="00000000-0000-0000-0000-000000000000" && PostDone === false && document.getElementById('BookKeepingSerialID').value!=0) {
		    const VerificationForm = document.getElementById('VerificationForm');
		    const formData = new FormData(VerificationForm);
		    const formDataObj = Object.fromEntries(formData.entries());

            formDataObj.BookKeepingSerialID = parseInt(formDataObj.BookKeepingSerialID, 10);

            try {
                formDataObj.Date = ConcatLocalDateAndTime2ISO(document.getElementById('Date').value);
            } catch {
                var d = new Date();
                formDataObj.Date = ConcatLocalDateAndTime2ISO(d.toISOString());
            }

            PostDone = true;
            let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/verifications',"POST",JSON.stringify(formDataObj));
            if (resultVariant=="success") { props.setSelectedVerificationData(jsondata); }
        }
        clearTimeout(typingTimeout);
		typingTimeout = setTimeout(handleSave, 475);
	}

    	function handleChangeTranRow(event){
			clearTimeout(typingTimeoutTranRow);
			typingTimeoutTranRow = setTimeout(handleSaveTranRow, 475);
		}

	async function handleSave(){
		setSaving(true);
		setResultText("");
		setResultVisible(false);
		const VerificationForm = document.getElementById('VerificationForm');
		const formData = new FormData(VerificationForm);
		const formDataObj = Object.fromEntries(formData.entries());

        try {
            formDataObj.Date = ConcatLocalDateAndTime2ISO(document.getElementById('Date').value, "00:00");
        } catch {
            var d = new Date();
            formDataObj.Date = ConcatLocalDateAndTime2ISO(d.toISOString());
        }

        if (props.VerificationData.Verification.Guid!=="00000000-0000-0000-0000-000000000000") {
            let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/verifications/'+props.VerificationData.Verification.Guid,"PUT",JSON.stringify(formDataObj));
            if (resultVariant!="success") {
                setResultVariant(resultVariant);   
                setResultText(resultText);
                setResultVisible(resultVisible);
            }
        }
		setSaving(false);

	} 
    
    async function handleSaveTranRow(){
		setSaving(true);
		setResultText("");
		setResultVisible(false);
		const VerificationForm = document.getElementById('FrmTranEdit');
		const formData = new FormData(VerificationForm);
		const formDataObj = Object.fromEntries(formData.entries());

        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/verifications/'+props.VerificationData.Verification.Guid+'/UpdateTranRow/'+tranToEditData.Guid,"PUT",JSON.stringify(formDataObj));
        if (resultVariant=="success") {
            props.setSelectedVerificationData(jsondata);
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);
        } else {
        }
		setSaving(false);
	}   

    const submitAttachment = (props2) => {

        const formData = new FormData();
        // formData.append("VerificationGuid", props.VerificationData.Verification.Guid);
        // formData.append("name", selectedFile.name);
        // formData.append("type", selectedFile.type);
        // formData.append("size", selectedFile.size);
        formData.append("file", selectedFile);
        
        setSaving(true);

        axios
        .post("/api/v1/upload/"+props.VerificationData.Verification.Guid, formData, {headers: {'AccessToken': localStorage.getItem('access_token')}} )
        .then((res) => {
            console.log(res.data);
            props.setSelectedVerificationData(res.data);
            setResultText("Filen laddades upp");
            setResultVariant("success");
            setResultVisible(true);
        })
        .catch((err) => {setResultText("Något gick fel");setResultVisible(true);});

        
        props.refresh();
        setSelectedFile(null);
        setSaving(false);
    };

    const handleFileChange = (file) => {
        setSelectedFile(file);
        setResultVisible(false);
        setResultText("");
    };

	const RemoveFile = async (event) => {
		event.preventDefault();
		const fileGuid = event.currentTarget.getAttribute("fileGuid");
		const url = '/api/Files/'+fileGuid;

		let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI(url,'DELETE');
		props.setSelectedRequestData(jsondata.Verification);
	};

    const Prev = async (event) => {
		event.preventDefault();
        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPIGet('/api/v1/bookkeeping/verifications/' + props.VerificationData.PrevGuid);
        props.setSelectedVerificationData(jsondata);
        //setPageNumber(1);
        const VerificationForm = document.getElementById('VerificationForm');
        VerificationForm.reset();
	};

    const Next = async (event) => {
		event.preventDefault();
        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPIGet('/api/v1/bookkeeping/verifications/' + props.VerificationData.NextGuid);
        props.setSelectedVerificationData(jsondata);
        //setPageNumber(1);
        const VerificationForm = document.getElementById('VerificationForm');
        VerificationForm.reset();
	};    

    return (
        <>
                <Modal show={autoBalanceModalshow} onHide={()=>setAutoBalanceModalshow(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Autobalancera</Modal.Title>                            
                    </Modal.Header>                            
                    <Modal.Body>

                        <Form id="FrmTemplate">

                            <Form.Group className="mb-3">                                                                
                                <Form.Label>Template</Form.Label>
                                <Form.Select name='AutoBalanceTemplateId'>
                                    <option value={0}>Select</option>
                                    {getOptions(props.MetaData.BookKeepingTemplates)}
                                </Form.Select>
                            </Form.Group>                      
                        </Form>                             

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="danger" onClick={()=>autoBalance()}>Balancera</Button> 
                        <Button variant="danger" onClick={()=>setAutoBalanceModalshow(false)}>Avbryt</Button>                            
                    </Modal.Footer>                            
                </Modal>

                <Modal show={tranEditModalshow} onHide={()=>setTranEditModalshow(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Editera</Modal.Title>                            
                    </Modal.Header>                            
                    <Modal.Body>

                        <Form id="FrmTranEdit">

                            <Form.Group className="mb-3">                                                                
                                <Form.Label>Konto</Form.Label>
                                <Form.Control type="number" name="BookKeepingAccountIdentifier" id="BookKeepingAccountIdentifier" placeholder="Konto" defaultValue={tranToEditData.BookKeepingAccountIdentifier} onChange={handleChangeTranRow} />

                                <Form.Label>Debet/Kredit</Form.Label>
                                <Form.Control  type="number" pattern="^\d*(\.\d{0,2})?$" step=".01" name="Amount" id="Amount" placeholder="Debet/Kredit" defaultValue={tranToEditData.Amount} onChange={handleChangeTranRow} />

                            </Form.Group>                      
                        </Form>                             

                    </Modal.Body>

                    <Modal.Footer>

                        <Button variant="danger" onClick={() => verRemoveRow(tranToEditData.Guid)}>Ta bort rad</Button>                            
                        <Button variant="danger" onClick={()=>setTranEditModalshow(false)}>Avbryt</Button>                            
                    </Modal.Footer>                            
                </Modal>                

                <Modal show={props.show} onHide={props.fn} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>{props.VerificationData.Verification.Identity}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Form id='VerificationForm' name='VerificationForm'>

                    {props.VerificationData.Verification.Guid==="00000000-0000-0000-0000-000000000000" &&
                    <Form.Group className="mb-3" >
                        <Form.Label>Serie</Form.Label>								                            
                        <Form.Select name="BookKeepingSerialID" id="BookKeepingSerialID">
                            <option value={0}>--- Välj ---</option>
                            {getOptions(props.MetaData.BookKeepingSerials)}
                        </Form.Select>&nbsp;
                    </Form.Group>
                    }
    
                    <Form.Group className="mb-3" >
                        <Form.Label>Beskrivning</Form.Label>								    
                        <Form.Control as="textarea" rows="3" type="text" name="Description" id="Description" placeholder="Produktbeskrivning" defaultValue={props.VerificationData.Verification.Description} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Date:</Form.Label>								
                        <Form.Control type="date" name="Date" id="Date" placeholder="Date" defaultValue={SplitoutLocalDateFromISO(props.VerificationData.Verification.Date)} onChange={handleChange} />
                    </Form.Group>     

                    <Form.Group className="mb-3" >
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            {props.VerificationData.Verification.InBalance ? 
                            <Accordion.Header>Trans ({props.VerificationData.Verification.BookKeepingTransactions.length})</Accordion.Header> : <Accordion.Header>Trans ({props.VerificationData.Verification.BookKeepingTransactions.length}) Obalanserad</Accordion.Header>}
                            <Accordion.Body>
                                {props.VerificationData.Verification.Guid!=="00000000-0000-0000-0000-000000000000" && <>
                                <Table responsive="sm">
                                    <thead>  
                                        <tr><th>Konto</th><th>Dim</th><th>Debet</th><th>Kredit</th><th></th></tr>
                                            {props.VerificationData.Verification.BookKeepingTransactions.map((row) => { 
                                            return <tr key={row.Guid} onClick={() => editTranRow(row) }>
                                            <td>{row.BookKeepingAccountIdentifier} {metaLookUpAccountTitle(props.MetaData, row.BookKeepingAccountIdentifier)}</td>

                                            <td></td>
                                            <td>{row.Amount>=0 && row.Amount}</td>
                                            <td>{row.Amount<=0 && Math.abs(row.Amount)}</td>

                                            <td><FaEdit onClick={() => editTranRow(row) }> </FaEdit></td>                            
                                        </tr> })}
                                    </thead>
                                </Table>
                                <Button onClick={()=>setAutoBalanceModalshow(true)} disabled={props.VerificationData.Verification.InBalance}>Autobalansera</Button>&nbsp;
                                <Button onClick={()=>verAddRow()}>Lägg till rad</Button>&nbsp;
                                {/* <Button onClick={()=>verRound()}>Avrunda</Button> */}
                                </>}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>  
                    </Form.Group>

                    <Form.Group className="mb-3" >
                    <Accordion>
                        <Accordion.Item eventKey="2" >
                            {props.VerificationData.Verification.BookKeepingDocuments.length == 0 ?
                                    <Accordion.Header>No document</Accordion.Header>
                                :
                                    <Accordion.Header>Documents ({props.VerificationData.Verification.BookKeepingDocuments.length})</Accordion.Header>
                            }
                            <> 
                                
                                <Accordion.Body style={{height:"500px"}}>
                                    {props.VerificationData.Verification.BookKeepingDocuments.map((d) => {                                        
                                        return <span style={{float:"left", margin:"8px"}}><ModalImage 
                                            small={"api/v1/upload/"+d.Guid+"/thumbnail"}
                                            large={"api/v1/upload/"+d.Guid+"/medium"}
                                            alt={props.VerificationData.Verification.Description}                                            
                                        /></span>
                                    } 
                                    )}
                                    <Form>
                                        <span style={{float:"left", margin:"8px", height:"500px"}}>
                                            <FileUploader id="Uploader" submitForm="" handleChange={handleFileChange} name="file"  label="Välj eller släpp en fil här" uploadedLabel="Fil vald, tryck på ladda upp!" multiple={false} maxSize={5} className="UploadBox"  />
                                            <Form.Label>Tillåtna filtyper: {fileTypes.map((ft) => {return <>{ft} </>} )}</Form.Label>
                                        </span>  

                                        <Form.Group className="mb-3">                            
                                            <Button disabled={false} className="QmeButton" variant="primary" type="button" onClick={() => submitAttachment(props.Refresh)} >Ladda upp</Button>
                                        </Form.Group>                                 
                                    </Form>
                                </Accordion.Body>
                            </>
                        </Accordion.Item>
                    </Accordion>  
                    </Form.Group>                       

                    <Form.Group className="mb-3" >
                    <Accordion>
                        <Accordion.Item eventKey="1" >
                            {props.VerificationData.Verification.Document=='' ?
                                <div>
                                    <Accordion.Header>No document</Accordion.Header>
                                    <Accordion.Body>

                                    {props.VerificationData.Verification.Guid!=="00000000-0000-0000-0000-000000000000" &&
                                    <div>
                                        <Form>
                                            <Form.Group className="mb-3">
                                                <FileUploader id="Uploader" submitForm="" handleChange={handleFileChange} name="file"  label="Välj eller släpp en fil här" uploadedLabel="Fil vald, tryck på ladda upp!" multiple={false} maxSize={5} style={{height:"60px", width:"100%"}} height="60px"/>
                                                <Form.Label>Tillåtna filtyper: {fileTypes.map((ft) => {return <>{ft} </>} )}</Form.Label>
                                            </Form.Group>  

                                            <Form.Group className="mb-3">                            
                                                <Button disabled={false} className="QmeButton" variant="primary" type="button" onClick={submitAttachment}>Ladda upp</Button>
                                            </Form.Group>                                 
                                        </Form>
                                    </div>    
                                    }
                                    </Accordion.Body>
                                </div>
                                :                           
                                <div> 
                                    <Accordion.Header>Document (Page {pageNumber} of {numPages})</Accordion.Header>
                                    <Accordion.Body>
                                    <div>
                                        {numPages>1 && props.VerificationData.Verification.Document!=="" &&
                                        <div><Button onClick={() => setPageOffset(-1)}>Prev</Button>&nbsp;<Button onClick={() => setPageOffset(+1)}>Next</Button></div>}
                                        <Document file={"Documents/"+props.VerificationData.Verification.Document} onLoadSuccess={onDocumentLoadSuccess}>
                                            <Page pageNumber={pageNumber} />
                                        </Document>
                                    </div>    
                                    </Accordion.Body>
                                </div>
                            }
                        </Accordion.Item>
                    </Accordion>  
                    </Form.Group>                                

                    <Form.Group className="mb-3"  hidden={!saving}>
                        <SpinnerX  />
                    </Form.Group>                                      
                    
                    <Form.Group className="mb-3"  hidden={!resultVisible}>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                    </Form.Group> 												 													
                  </Form>  
                                      
                  </Modal.Body>
                  <Modal.Footer>
                  { props.VerificationData.Verification.Guid!=="00000000-0000-0000-0000-000000000000" && <>
                    {props.VerificationData.PrevGuid!=="00000000-0000-0000-0000-000000000000" && <Button variant="danger" onClick={Prev}>Föregående</Button>}
                    {props.VerificationData.NextGuid!=="00000000-0000-0000-0000-000000000000" && <Button variant="danger" onClick={Next}>Nästa</Button>}
                  </> }
                  <Button variant="danger" onClick={props.fn}>Close</Button>
                  </Modal.Footer>
              </Modal>  
        </>
      );      
};